import { useEffect, useRef } from 'react'

/**
 * recommended method for storing and accessing state/props from previous render cycle
 * @param value
 * @returns {undefined}
 */
export const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
